import { withStyles } from '@mui/styles';
import IncludedTherapies from './included-therapies-question';

export default IncludedTherapies;
